import {
  AlignItems,
  Box,
  JustifyContent,
  ReadingOptimized,
  Banner,
  BannerVariant,
  BannerStatus,
  PlainLink,
  BannerLeftAccessoryType,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import { REFER_SHARE_LINK } from "../consts";

export const ExpiredReferralCode = () => (
  <Box
    layout="flex"
    flexDirection="column"
    justifyContent={JustifyContent.Center}
    maxWidth={["100%", "500px"]}
    height="100%"
    css={{ margin: "auto" }}
  >
    <ReadingOptimized alignText={AlignItems.FlexStart} textWidth="100%">
      <Banner
        variant={BannerVariant.Light}
        leftAccessory={{
          type: BannerLeftAccessoryType.Status,
          status: BannerStatus.Warning,
        }}
        title={<Trans>Sorry, this referral sign up link has expired</Trans>}
      >
        <Trans>
          Please ask the person referring you to share a new referral link from
          their GoCardless dashboard{" "}
          <PlainLink href={REFER_SHARE_LINK} decoration="underline">
            https://manage.gocardless.com/refer/
          </PlainLink>{" "}
          so that you can sign up with a referral bonus.
        </Trans>
      </Banner>
    </ReadingOptimized>
  </Box>
);
